import * as React from 'react';

import type { RemindersClient } from '@/api/reminders-client';
import { HttpRemindersClient } from '@/api/reminders-client.http';

// =============================================================================
// reminders-client-context.tsx — Injection du RemindersClient (DI seam).
// =============================================================================
// A-16 / V-SUIVI-FOURN-relance. Permet de substituer le client sans toucher l'UI. Par DÉFAUT : l'adaptateur
// HTTP RÉEL — la route réelle n'a donc AUCUN provider à câbler (parité supplier-monitoring). Les tests de
// composant injectent le StubRemindersClient via ce provider (enveloppe locale).

const defaultRemindersClient: RemindersClient = new HttpRemindersClient();

const RemindersClientContext =
  React.createContext<RemindersClient>(defaultRemindersClient);

export interface RemindersClientProviderProps {
  client?: RemindersClient | undefined;
  children: React.ReactNode;
}

export function RemindersClientProvider({
  client = defaultRemindersClient,
  children,
}: RemindersClientProviderProps): React.JSX.Element {
  return (
    <RemindersClientContext.Provider value={client}>
      {children}
    </RemindersClientContext.Provider>
  );
}

export function useRemindersClient(): RemindersClient {
  return React.useContext(RemindersClientContext);
}
